module.exports = __webpack_public_path__ + "img/wait@2x.89c670f5.png";